import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "price-content" }
const _hoisted_4 = { class: "price" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "subtitle-features" }
const _hoisted_7 = { class: "features" }
const _hoisted_8 = { class: "feature-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-subscription", $props.type]),
    onMouseover: _cache[0] || (_cache[0] = ($event: any) => ($setup.hover = true)),
    onMouseleave: _cache[1] || (_cache[1] = ($event: any) => ($setup.hover = false))
  }, [
    _createElementVNode("img", {
      class: "icon",
      src: $props.icon,
      alt: "Icon"
    }, null, 8, _hoisted_1),
    _createElementVNode("h2", _hoisted_2, _toDisplayString($props.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString($props.price), 1),
      _cache[2] || (_cache[2] = _createElementVNode("span", { class: "month" }, "/ Month", -1))
    ]),
    _createElementVNode("p", _hoisted_5, _toDisplayString($props.subtitle), 1),
    _createElementVNode("button", {
      class: "action-button",
      onClick: $setup.onRedirectForm
    }, _toDisplayString($props.buttonText), 1),
    _createElementVNode("p", _hoisted_6, _toDisplayString($props.subtitleFeatures), 1),
    _createElementVNode("ul", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.features, (feature) => {
        return (_openBlock(), _createElementBlock("li", { key: feature }, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "content-checkmark" }, [
            _createElementVNode("div", { class: "checkmark" })
          ], -1)),
          _createElementVNode("span", _hoisted_8, _toDisplayString(feature), 1)
        ]))
      }), 128))
    ])
  ], 34))
}